export default "__VITE_ASSET__CcPRpo8G__"